import React from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input, Button, NavbarBrand, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { baseUrl } from 'Config';
import Footer from '@components/Footer';


class ResetPassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            password: '',
            password2: '',
            validationError: ''
        }

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.token = this.props.match.params.token;
    }

    onChange(e) {
        const trg = e.target;

        this.setState(prevState => {
            prevState[trg.name] = trg.value;
            prevState.validationError = '';
            return prevState;
        });
    }

    validate() {
        let isValid = true;

        if (this.state.password.length < 6) {
            this.setState({ validationError: 'Password length must be at least 6 characters' });
            isValid = false;
        }

        if (isValid && this.state.password !== this.state.password2) {
            this.setState({ validationError: 'Passwords don\'t match' });
            isValid = false;
        }
        return isValid;
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.validate()) {
            axios({
                method: 'POST',
                url: baseUrl + '/p/reset-password/',
                data: {
                    password: this.state.password,
                    token: this.token
                }
            })
                .then(resp => {
                    this.props.history.push('/login');
                    toast.success('Password has been updated');
                })
                .catch(e => toast.error('Error occurred while processing'));
        }
    }

    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header">Enter new password</div>
                                <div className="card-block">
                                    <Form onSubmit={this.onSubmit}   >
                                        <FormGroup row>
                                            <Label htmlFor="password" sm={3} className="text-right">New password :</Label>
                                            <Col sm={6}>
                                                <Input name="password" type="password" value={this.state.password} maxLength="255" onChange={this.onChange} />
                                                {this.state.validationError.length > 0 &&
                                                    <div className="font-weight-bold" style={{ fontSize: '0.7rem', color: '#c00' }}>{this.state.validationError}</div>
                                                }
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label htmlFor="password" sm={3} className="text-right">Confirm new password :</Label>
                                            <Col sm={6}>
                                                <Input name="password2" type="password" value={this.state.password2} maxLength="255" onChange={this.onChange} />
                                            </Col>
                                        </FormGroup>
                                        <hr />
                                        <FormGroup row>
                                            <Col>
                                                <Link to="/login">
                                                    <button className="btn btn-secondary-new">Cancel</button>
                                                </Link>
                                            </Col>
                                            <Col className="text-right">
                                                <button
                                                    type="submit"
                                                    className="float-right btn btn-primary-new"
                                                    disabled={!this.state.password.length}
                                                >Send</button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/ResetPassword.js